import { render } from "./backTop.vue?vue&type=template&id=d9bd344e&scoped=true"
import script from "./backTop.vue?vue&type=script&lang=ts"
export * from "./backTop.vue?vue&type=script&lang=ts"

import "./backTop.vue?vue&type=style&index=0&id=d9bd344e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d9bd344e"

export default script